(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/assets/javascripts/models/correct-row.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/assets/javascripts/models/correct-row.js'); 
'use strict';

svs.sport.result_boxes.models.CorrectRow = Backbone.Model.extend({
  log: new svs.core.log.Logger('svs.sport.result_boxes.models.CorrectRow'),
  defaults: {
    correctRows: []
  },

  initialize: function(correctRows, isFinished) {
    var headline = isFinished ? 'Målrikast' : 'Målrikast just nu';
    this.set('headline', headline, { silent: true });
    this.createItemArray(correctRows);
    this.listenTo(
      svs.sport.result_boxes.models.forecast,
      'forecastStatusChanged',
      this.createItemArray
    );
  },

  createItemArray: function(correctRows) {
    this.correctRowsArr = [];
    var self = this;

    for (var i = 0; i < 8; i++) {
      var tmpData = {},
        match = correctRows[i];
      tmpData.leftColumn = {
        eventNum: match.get('eventNumber'),
        nameHomeTeam: match.get('match').participants[0].shortName,
        nameAwayTeam: match.get('match').participants[1].shortName,
        scoreHomeTeam: match.get('homeTeamGoals'),
        scoreAwayTeam: match.get('awayTeamGoals'),
        isInBet: match.get('isSetInAnyRow'),
        isFinalized: match.get('drawFinalized')
      };

      i++;

      match = correctRows[i];
      tmpData.rightColumn = {
        eventNum: match.get('eventNumber'),
        nameHomeTeam: match.get('match').participants[0].shortName,
        nameAwayTeam: match.get('match').participants[1].shortName,
        scoreHomeTeam: match.get('homeTeamGoals'),
        scoreAwayTeam: match.get('awayTeamGoals'),
        isInBet: match.get('isSetInAnyRow'),
        isFinalized: match.get('drawFinalized')
      };

      self.correctRowsArr.push(tmpData);
    }

    this.set('correctRows', this.correctRowsArr);
  }
});

 })(window);